/*
 * What a signed-in user's groups and folder roles let them do in the DAM.
 * Emails compare case-insensitively: logins and group members keep whatever
 * case was typed, and a mismatch here must not take an admin's tools away.
 */
const lower = (s) => String(s || '').toLowerCase()

const inGroup = (email, group) =>
  !!group && (group.members || []).some((m) => lower(m) === lower(email))

/* Admins and content admins both see Analytics */
export const canViewAnalytics = (email, groups) =>
  inGroup(email, (groups || {})['SYS.admins']) ||
  inGroup(email, (groups || {})['SYS.contentadmins'])

const VIEW_ONLY_ROLES = ['viewer', 'traverser']

/*
 * True for someone with nothing to do in the DAM: not an admin or content
 * admin, and no folder role beyond viewing. Their place is the app.
 *
 * Any doubt keeps them here. Groups that failed to load (no SYS.admins) answer
 * false, so a failed request can't send an editor away, and a custom role
 * counts as more than viewing.
 */
export const isAppOnlyUser = (email, groups, folders) => {
  if (!email || !groups || !groups['SYS.admins']) return false
  if (canViewAnalytics(email, groups)) return false
  const entities = new Set([
    lower(email),
    ...Object.keys(groups)
      .filter((id) => inGroup(email, groups[id]))
      .map(lower),
  ])
  return !Object.values(folders || {}).some((folder) =>
    Object.entries((folder && folder.contentRoles) || {}).some(
      ([entity, grant]) =>
        entities.has(lower(entity)) &&
        ((grant && grant.roleIds) || []).some(
          (role) => !VIEW_ONLY_ROLES.includes(role),
        ),
    ),
  )
}
